import PrescriberTabs from './PrescriberTabs'

export default PrescriberTabs
